import { useEffect } from 'react'

import { useAppSelector } from 'app-redux/hooks'

import PhatDropdown from 'components/formElements/PhatDropdown'

import { PRICE_CODES } from 'types/active'

type Props = {
  value?: string
  onChange: (value: string) => void
}

const SortingDropdown = ({ value = 'oracleCard__name', onChange }: Props) => {
  const priceSource = useAppSelector(state => state.active.priceSource)
  const primaryPriceSource = PRICE_CODES[priceSource[0]] || undefined
  const priceValue = `prices__${primaryPriceSource || 'ck'}`

  // If the user updates their primary price source we update the search value
  useEffect(() => {
    if (value.includes('prices__')) onChange(priceValue)
  }, [priceSource])

  return (
    <PhatDropdown
      inlineHeader
      header="Sort by:"
      options={[
        { label: 'Alphabet', onClick: () => onChange('oracleCard__name'), id: 'oracleCard__name' },
        { label: 'CMC', onClick: () => onChange('oracleCard__cmc'), id: 'oracleCard__cmc' },
        { label: 'Power', onClick: () => onChange('oracleCard__powerint'), id: 'oracleCard__powerint' },
        { label: 'Toughness', onClick: () => onChange('oracleCard__toughnessint'), id: 'oracleCard__toughnessint' },
        { label: 'Rarity', onClick: () => onChange('rarity_id'), id: 'rarity_id' },
        { label: 'Artist', onClick: () => onChange('artistName'), id: 'artistName' },
        { label: 'Price', onClick: () => onChange(priceValue), id: priceValue },
        { label: 'EDH Salt Score', onClick: () => onChange('salt'), id: 'salt' },
        { label: 'EDHREC Rank', onClick: () => onChange('edhrec'), id: 'edhrec' },
      ]}
      value={value}
    />
  )
}

export default SortingDropdown
